import md5 from 'md5'

import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './User.d'

const ROOT_URL = '/core/users'

export const UserRepository = {
  Search: async (params: Repo.User.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.User.Search.Response>(url)
  },

  FindById: async ({ userId }: Repo.User.FindById.Params) => {
    const url = ROOT_URL + `/${userId}`
    return await WitaConnector.get<Repo.User.FindById.Response>(url)
  },

  Create: async (params: Repo.User.Create.Params) => {
    const url = ROOT_URL
    return await WitaConnector.post<Repo.User.Create.Response>(url, params)
  },

  Edit: async ({ id, ...params }: Repo.User.Edit.Params) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.User.Edit.Response>(url, params)
  },

  ResetPassword: async ({ id }: Repo.User.ResetPassword.Params) => {
    const url = ROOT_URL + `/${id}/password-reset`
    return await WitaConnector.put<Repo.User.ResetPassword.Response>(url, null)
  },

  ChangePassword: async ({
    id,
    ...params
  }: Repo.User.ChangePassword.Params) => {
    const url = ROOT_URL + `/${id}/password-change`
    const data = { password: md5(params.password) }
    return await WitaConnector.put<Repo.User.ChangePassword.Response>(url, data)
  },
}
